import instance from "./request.js"

export function getDesignSave(data) {
	return instance.post('/admin/' + data.wsid + '/design/save', {
		data,
		withCredentials: true
	});
}

export function getAutocomplete(params) {
	return instance.get('/admin/' + params.wsid + '/products/autocomplete', {
		params,
		withCredentials: true
	});
}

export function getCategories(params) {
	return instance.get('/admin/' + params.wsid + '/design/categories', {
		...params,
		withCredentials: true
	});
}

export function getDesignGetCategories(params) {
	return instance.post('/admin/' + params.wsid + '/design/getCategories', {
		...params,
		withCredentials: true
	});
}

export function getDesignHome(params) {
	return instance.get('/admin/' + params.wsid + '/design/home', {
		params,
		withCredentials: true
	});
}

export function getDesignShow(params) {
	return instance.get('/admin/' + params.wsid + '/design/show', {
		params,
		withCredentials: true
	});
}
export function getDesignProducts(params) {
	return instance.get('/admin/' + params.wsid + '/design/products', {
		params,
		withCredentials: true
	});
}
export function getDesignDelFileManagerDirectories(data) {
	return instance.delete('/admin/' + data.wsid + '/file_manager/directories', {
		data,
		withCredentials: true
	});
}



export function getSetDesignCategoriesData(data) {
	let obj = data
	let sort = obj.sort ? obj.sort : ''
	delete obj["sort"]
	let str = '?' + sort
	for (let k in obj) {
		if (str == '?') {
			str = str + k + '=' + obj[k]
		} else {
			str = str + '&' + k + '=' + obj[k]
		}
	}
	
	return instance.get('/categoriesData' + str);
}


export function getDesignGetAllCategory(data) {
	let obj = data
	let sort = obj.sort ? obj.sort : ''
	delete obj["sort"]
	let str = '?' + sort
	for (let k in obj) {
		if (str == '?') {
			str = str + k + '=' + obj[k]
		} else {
			str = str + '&' + k + '=' + obj[k]
		}
	}
	
	
	return instance.get('/admin/' + data.wsid + '/design/getAllCategory' + str, {
		// params:data,
		withCredentials: true
	});
}

export function getDesignFileManagersFiles(data) {
	return instance.delete('/admin/' + data.wsid + '/file_manager/files', {
		data,
		withCredentials: true
	});
}
export function getSearchDesignFileManagersFiles(data) {
	return instance.get('/admin/' + data.wsid + '/file_manager/files', {
		data,
		withCredentials: true
	});
}

export function getProductsAutocomplete(data) {
	return instance.get('/admin/' + data.wsid + '/products/autocomplete', {
		params: data,
		withCredentials: true
	});
}
export function getCategoriesAutocomplete(data) {
	return instance.get('/admin/' + data.wsid + '/categories/autocomplete', {
		params: data,
		withCredentials: true
	});
}
export function getPagesAutocomplete(data) {
	return instance.get('/admin/' + data.wsid + '/pages/autocomplete', {
		params: data,
		withCredentials: true
	});
}
export function getPageCategoriesAutocomplete(data) {
	return instance.get('/admin/' + data.wsid + '/page_categories/autocomplete', {
		params: data,
		withCredentials: true
	});
}
export function getBrandsAutocomplete(data) {
	return instance.get('/admin/' + data.wsid + '/brands/autocomplete', {
		params: data,
		withCredentials: true
	});
}


export function getDesignAllSetting(data) {
	return instance.post('/admin/' + data.wsid + '/design/allSetting', {
		...data,
		withCredentials: true
	});
}




export function getDesignFileManagersRename(data) {
	return instance.post('/admin/' + data.wsid + '/file_manager/rename', {
		...data,
		withCredentials: true
	});
}


export function getDesignAddFileManagerDirectories(data) {
	return instance.post('/admin/' + data.wsid + '/file_manager/directories', {
		...data,
		withCredentials: true
	});
}

export function getNewDesignSetting(data) {
	return instance.get('/admin/' + data.wsid + '/design/setting', {
		...data,
		withCredentials: true
	});
}







export function getaccountOrders(data) {
	return instance.get('/account/orders/data', {
		params: {
			...data,
		}
	});
}

export function getaccountOrderItem(data) {
	return instance.get('/account/orders/data' + '/' + data.orderId, {});
}


export function getWhatsapp_chat(data) {
	return instance.get('/whatsapp_chat/sms', {});
}

export function getaccountOrderCancel(data) {
	return instance.post('/orders/' + data.orderId + '/cancel', {});
}

export function getaccountEditData(data) {
	return instance.get('/account/edit/data', {});
}


export function l_commentComments(data) {
	return instance.post('/l_comment/comments', {
		...data
	});
}

export function sendSubscribe(data) {
	return instance.post('/subscribe', {
		...data
	});
}



export function getL_commentComments(data) {
	return instance.get('/l_comment/comments', {
		params: data,
	});
}


export function getl_comment_upload(data) {
	// return instance.post('/files', {
	// 	...data
	// });
	return instance({
		method: "post",
		url: '/l_comment/upload',
		data: data.formData,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}


export function getCartsMini(data) {
	return instance.get('/carts/mini', {
		...data
	});
}


export function getaccountfiles(data) {
	// return instance.post('/files', {
	// 	...data
	// });
	return instance({
		method: "post",
		url: '/files',
		data: data.formData,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

export function getputCarts(data) {
	return instance.put('/carts/' + data.id, {
		...data
	});
}
export function getDelCarts(data) {
	return instance.delete('/carts/' + data.id, {
		...data
	});
}

export function getTypeProducts(data) {
	return instance.get('/getTypeProducts', {
		params: data
	});
}


export function getaccountUpdateData(data) {
	return instance.post('/account/edit/data', {
		...data
	});
}

export function getaccountUpdatepassword(data) {
	return instance.post('/account/password', {
		...data
	});
}
export function getaccountGetAddresses(data) {
	return instance.get('/account/get_addresses', {
		...data
	});
}

export function getaccountWishlistData(data) {
	return instance.get('/account/wishlist/data', {
		...data
	});
}
export function getCancelWishlistData(data) {
	return instance.delete('/account/wishlist/' + data.id);
}

export function getRmasData(data) {
	return instance.get('/account/rmas/data');
}
export function getRmasDataDetail(data) {
	return instance.get('/account/rmas/data/' + data.id);
}
export function getLoginOut(data) {
	return instance.get('/logout/logout');
}

export function getCommissionShopOrders(data) {
	return instance.get('/commission/shop/orders', {
		params: data,
	});
}

export function getCommissionCashapply(data) {
	return instance.post('/commission/shop/cash_apply', {
		data,
	});
}
export function getCommissionShopUsers(data) {
	return instance.get('/commission/shop/users', {
		data,
	});
}

export function getOrdersPayData(data) {
	return instance.get('/orders/' + data.id + '/payData', {
		data,
	});
}

export function getStripeCapture(data) {
	return instance.post('/stripe/capture', {
		...data,
	});
}
export function getPagesData(data) {
	return instance.get('/pages/' + data.id + '/data', {
		...data,
	});
}

export function getPageCategories(data) {
	return instance.get('/page_categories/' + data.id + '/data', {
		...data,
	});
}
export function getBrandsData(data) {
	return instance.get('/brandsPage/data', {
		...data,
	});
}
export function getBrandsGoodsData(data) {
	return instance.get('/brandsData/' + data.id, {
		...data,
	});
}
export function getProductsSearchData(data) {
	return instance.get('products/search/data', {
		params: data
	});
}


export function getOrdersComplete(data) {
	return instance.post('orders/' + data.id + '/complete', {});
}


export function getRmasStore(data) {
	return instance.post('/account/rmas/store', {
		...data
	});
}

export function getCheckoutSuccessData(data) {
	return instance.get('/checkout/successData', {
		params:{
			...data
		}
		
	});
}

export function getUrl_name(data) {
	return instance.post('/url_name', {
		...data
	});
}

export function getSearchCategory(data) {
	return instance.get('/search/category', {
	});
}


export function getCategoriesData(data) {
	let obj = data.obj
	let sort = obj.sort ? obj.sort : ''
	delete obj["sort"]
	let str = '?' + sort
	for (let k in obj) {
		if (str == '?') {
			str = str + k + '=' + obj[k]
		} else {
			str = str + '&' + k + '=' + obj[k]
		}

	}
	console.log('getCategoriesData', obj)
	return instance.get('/categoriesData' + str);
}





// export function getDesignFileManagerupload(data) {
// 	return instance.post('/admin/' + data.wsid +  '/file_manager/directories', { data.formData,  withCredentials: true });
// }

// export function getDesignFileManagerupload(data) {
// 	let formData = data.formData
// 	return instance.post('/admin/' + data.wsid +  '/file_manager/directories', { data,  withCredentials: true });
// }

export function getDesignFileManagerupload(data) {
	// return instance.post('/admin/' + data.wsid + '/file_manager/directories', {
	// 	withCredentials: true,
	// 	data: data.formData,
	// 	headers: {
	// 		'Content-Type': 'application/x-www-form-urlencoded'
	// 	}
	// });
	return instance({
		method: "post",
		url: '/admin/' + data.wsid + '/file_manager/upload',
		data: data.formData,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}



export function getDesignGetProducts(data) {
	return instance.post('/admin/' + data.wsid + '/design/getProducts', {
		ids: data.ids,
		withCredentials: true
	});
}
export function getDesignGetFonts(data) {
	return instance.get('/admin/' + data.wsid + '/design/fonts', {
		withCredentials: true
	});
}
export function getDesignProductsDetail(data) {
	return instance.get('/admin/' + data.wsid + '/design/productsdetail', {
		params: {
			product_id: data.product_id,
		}
	});
}



export function getProducts(data) {
	return instance.post('/getProducts', {
		...data,
		withCredentials: true
	});
}

export function getproductsDetail(data) {
	return instance.post('/products/detail', {
		...data,
		withCredentials: true
	});
}

export function getShow(data) {
	return instance.get('/show', {
		...data,
		withCredentials: true
	});
}

export function getFrontCategories(data) {
	return instance.post('/getCategories', {
		...data,
		withCredentials: true
	});
}


export function getSetting(data) {
	if (process.env.NODE_ENV == 'development') {
		return instance.get('/bddesign/setting', {
			...data,
			withCredentials: true
		});
	} else {
		return instance.get('/setting', {
			...data,
			withCredentials: true
		});
	}

}


export function getDesignSetting(data) {

	return instance.get('/admin/' + data.wsid + '/setting', {
		...data,
		withCredentials: true
	});
}

export function getSetLocale(params) {
	return instance.get('/locale', {
		params,
		withCredentials: true
	});
}
export function getSetCurrency(params) {
	return instance.get('/currency', {
		params,
		withCredentials: true
	});
}

export function getCategoryProduct(data) {
	console.log('getCategoryProduct',data)
	return instance.post('/getCategoryProduct', {
		...data,
	});
}

export function getmessageSend(data) {
	return instance.post('/message', {
		...data,
	});
}

export function designGetCategoryProduct(data) {
	return instance.post('/admin/' + data.wsid + '/design/getCategoryProduct', {
		...data,
	});
}


export function designCategoriesSonCategory(data) {
	return instance.get('/admin/' + data.wsid + '/categories/sonCategory', {
		params:{
			...data
		},
	});
}


export function designTemplate(data) {
	return instance.post('/admin/' + data.wsid + '/design/template', {
		...data,
	});
}

export function designTemplateDesign(data) {
	return instance.post('/admin/' + data.wsid + '/design/templateDesign', {
		...data,
	});
}







export function getAccountCollect(data) {
	return instance.post('account/collect', {
		...data,
		withCredentials: true
	});
}
export function getAccountAddCarts(data) {
	return instance.post('carts', {
		...data,
		withCredentials: true
	});
}


export function getCartsData(data) {
	return instance.get('/carts/data', {
		...data,
		withCredentials: true
	});
}




export function getCartsSelect(data) {
	return instance.post('/carts/select', {
		...data,
		withCredentials: true
	});
}
export function getCartsUnselect(data) {
	return instance.post('carts/unselect', {
		...data,
		withCredentials: true
	});
}
export function getCartsCartId(data) {
	return instance.put('carts/' + data.cart_id, {
		...data,
		withCredentials: true
	});
}
export function getCartsCartIdDel(data) {
	return instance.delete('carts/' + data.cart_id, {
		...data,
		withCredentials: true
	});
}


export function getCheckoutData(data) {
	return instance.get('/checkout/data', {
		...data,
	});
}

export function getZones(data) {
	return instance.get('/countries/' + data.id + '/' + 'zones', {});
}

export function getCheckCode(data) {
	return instance.post('/discount_code/check', {
		...data
	});
}

export function getCheckoutPayWay(data) {
	return instance.put('/checkout', {
		...data
	});
}

export function getCheckoutAddresses(data) {
	return instance.post('/account/addresses', {
		...data
	});
}

export function getCheckoutUpdateAddresses(data) {
	return instance.put('/account/addresses/' + data.id, {
		...data
	});
}

export function getCheckoutConfirm(data) {
	return instance.post('/checkout/confirm', {
		...data
	});
}

export function getcheckoutAddress(data) {
	return instance.get('/checkout/address', {
		...data
	});
}